import { useEffect } from 'react'

/**
 * Arrow keys move the selected item by one page px, ten with Shift. `locked`
 * is the lock that forbids the move: Item.js passes an editor text box's own
 * lock and `false` for a classic item.
 */
export const useNudgeItem = ({
  isItemSelected,
  dragDisabled,
  isEditing,
  locked = false,
  controlledX,
  controlledY,
  setControlledX,
  setControlledY,
  setThisItemX,
  setThisItemY,
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isItemSelected || dragDisabled || isEditing || locked) return

      const nudgeAmount = event.shiftKey ? 10 : 1 // Check if "Shift" is pressed

      switch (event.key) {
        case 'ArrowUp':
          event.preventDefault()
          setControlledY((prevY) => prevY - nudgeAmount)
          setThisItemY(controlledY - nudgeAmount)
          break
        case 'ArrowDown':
          event.preventDefault()
          setControlledY((prevY) => prevY + nudgeAmount)
          setThisItemY(controlledY + nudgeAmount)
          break
        case 'ArrowLeft':
          event.preventDefault()
          setControlledX((prevX) => prevX - nudgeAmount)
          setThisItemX(controlledX - nudgeAmount)
          break
        case 'ArrowRight':
          event.preventDefault()
          setControlledX((prevX) => prevX + nudgeAmount)
          setThisItemX(controlledX + nudgeAmount)
          break
        default:
          break
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [
    isItemSelected,
    dragDisabled,
    isEditing,
    locked,
    controlledX,
    controlledY,
    setControlledX,
    setControlledY,
    setThisItemX,
    setThisItemY,
  ])
}

export default useNudgeItem
